'use client';

import { useId } from 'react';
import { Gradient } from '../gradient';

export const Control = () => {
  const gradientId = useId();

  return (
    <>
      <Gradient gradientId={gradientId} />
      <svg viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_3451_22525)">
          <path
            d="M145.742 200.544C151.356 200.544 155.51 200.264 155.931 200.236L155.173 189.008C154.893 189.008 128.957 190.72 115.625 185.303C105.015 180.896 93.3381 151.143 88.1174 124.759C84.8333 108.058 86.6297 102.809 88.1174 101.153C88.398 100.788 89.184 99.8338 92.1873 99.8338H102.545C105.52 108.844 110.32 117.91 117.533 117.91H138.248V106.683H118.207C115.324 102.409 113.223 97.6571 112.004 92.6483L110.853 88.5222H92.0189C89.6313 88.3897 87.245 88.8038 85.0416 89.7328C82.8382 90.6619 80.8758 92.0814 79.3038 93.8833C74.4479 99.8058 73.6901 109.967 77.0864 126.864C79.7664 140.471 83.7712 153.782 89.0436 166.609C95.8362 182.636 103.387 192.432 111.499 195.688C121.407 199.786 135.974 200.544 145.742 200.544Z"
            fill={`url(#${gradientId})`}
          />
          <path
            opacity="0.2"
            d="M121.721 106.599H138.309V117.91H124.275L121.721 106.599Z"
            fill="#2D5B5B"
          />
          <path
            opacity="0.2"
            d="M155.925 200.264C155.476 200.264 151.462 200.572 145.736 200.572C144.781 200.572 143.799 200.572 142.761 200.572L140.234 189.345C148.458 189.598 155.027 189.177 155.167 189.148L155.925 200.264Z"
            fill="#2D5B5B"
          />
          <path
            d="M254.257 200.544C248.643 200.544 244.489 200.264 244.068 200.236L244.826 189.008C245.107 189.008 271.042 190.72 284.375 185.303C294.985 181.009 306.689 151.172 311.882 124.787C315.166 108.086 313.37 102.837 311.882 101.181C311.602 100.816 310.816 99.862 307.812 99.862H297.455C294.48 108.872 289.68 117.938 282.466 117.938H261.752V106.711H281.793C284.676 102.437 286.776 97.6853 287.996 92.6764L289.147 88.5503H307.981C310.366 88.4145 312.751 88.8241 314.954 89.7482C317.157 90.6723 319.121 92.0865 320.696 93.8834C325.552 99.8059 326.31 109.967 322.913 126.864C320.233 140.471 316.228 153.783 310.956 166.609C304.163 182.637 296.613 192.432 288.501 195.688C278.593 199.786 264.025 200.544 254.257 200.544Z"
            fill={`url(#${gradientId})`}
          />
          <path
            opacity="0.2"
            d="M278.274 106.599H261.686V117.91H275.72L278.274 106.599Z"
            fill="#2D5B5B"
          />
          <path
            opacity="0.2"
            d="M244.068 200.264C244.517 200.264 248.531 200.572 254.257 200.572C255.212 200.572 256.194 200.572 257.233 200.572L259.759 189.345C251.535 189.598 244.967 189.177 244.826 189.148L244.068 200.264Z"
            fill="#2D5B5B"
          />
          <path
            d="M140.971 313.465V319.836H259.028V313.465H248.923L241.372 302.658L207.016 288.989V221.933H192.982V288.989L158.626 302.658L151.075 313.465H140.971Z"
            fill={`url(#${gradientId})`}
          />
          <path
            d="M189.081 230.887H210.891V223.841H189.081V230.887Z"
            fill={`url(#${gradientId})`}
          />
          <path
            opacity="0.2"
            d="M189.104 228.305L210.885 227.35V223.842H189.104V228.305Z"
            fill="#2D5B5B"
          />
          <path
            d="M127.807 81C127.807 81 133.42 172.335 147.735 197.597C162.05 222.859 192.842 224.992 199.999 224.992C207.157 224.992 237.892 222.831 252.263 197.597C266.634 172.364 272.192 81 272.192 81H127.807Z"
            fill={`url(#${gradientId})`}
          />
          <path
            d="M174.733 214.052C174.733 214.052 160.39 205.163 154.784 194.58C152.555 190.371 151.451 187.777 150.098 182.856C148.608 177.432 147.844 168.175 147.844 168.175C147.844 168.175 149.244 177.22 151.016 182.474C152.603 187.177 153.831 189.591 156.117 193.67C161.777 203.773 174.733 214.052 174.733 214.052Z"
            fill="white"
          />
          <path
            opacity="0.2"
            d="M248.92 313.493H151.072L153.767 309.592L243.811 306.195L248.92 313.493Z"
            fill="#2D5B5B"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_3451_22525"
            x="69"
            y="77"
            width="262"
            height="250.836"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22525"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22525"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  );
};
